var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MyGamesHeader',{attrs:{"userLinks":_vm.user_links,"headerBGColor":_vm.headerBGColor,"headerTextColor":_vm.headerTextColor,"promoName":_vm.promo_name,"hideNavigation":true,"hideLogo":true}})}
var staticRenderFns = []

export { render, staticRenderFns }